module.exports = __webpack_public_path__ + "static/media/53.27bcf435.jpg";